export default "__VITE_ASSET__BaFQTYq3__"